// Weather in one rounded line: "56°F, wind 4 mph (gusts 6)".
// Missing pieces are left out; gusts only when stronger than the wind.
export function formatWeather(w, t) {
  if (!w || w.temperature === null || w.temperature === undefined || Number.isNaN(Number(w.temperature))) return "";
  const temp = `${Math.round(Number(w.temperature))}°F`;
  const wind = Number(w.windSpeed);
  if (!Number.isFinite(wind)) return temp;
  const gust = Number(w.windGust);
  const g = Number.isFinite(gust) && Math.round(gust) > Math.round(wind) ? Math.round(gust) : null;
  return g !== null ? t("weather.lineGusts", { temp, wind: Math.round(wind), gust: g }) : t("weather.line", { temp, wind: Math.round(wind) });
}
